module.exports = __webpack_public_path__ + "img/Praha_9_logo_menu.cf88b0ee.png";